module.exports = __webpack_public_path__ + "img/icon-step-3.2ee648d1.svg";